
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-document-storage-solutions",
      function () {
        return require("private-next-pages/office-document-storage-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/office-document-storage-solutions"])
      });
    }
  